import React, { useState, useEffect } from 'react';
import './BlogsResources.css';

const BlogsResources = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubstackPosts = async () => {
      try {
        // Fetch from Netlify serverless function
        const response = await fetch('/.netlify/functions/substack-feed');

        if (!response.ok) {
          throw new Error('Failed to fetch feed');
        }

        const data = await response.json();

        if (!data.success || !data.posts) {
          throw new Error('Invalid response from feed');
        }

        let posts = data.posts;

        // Always ensure exactly 3 cards
        const fallbackCard = {
          id: 'fallback',
          title: 'Explore all insights',
          excerpt: 'Thought pieces, case notes, and practical perspectives on transformation for growing businesses.',
          date: '—',
          link: 'https://richaowleyes.substack.com/',
          isReal: false
        };

        // Fill with fallback cards if needed
        while (posts.length < 3) {
          posts.push({ ...fallbackCard, id: `fallback-${posts.length}` });
        }

        setBlogs(posts);
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch Substack posts:', error);
        // Fallback: show 3 fallback cards
        const fallbackCards = Array.from({ length: 3 }, (_, i) => ({
          id: `fallback-${i}`,
          title: 'Explore all insights',
          excerpt: 'Thought pieces, case notes, and practical perspectives on transformation for growing businesses.',
          date: '—',
          link: 'https://richaowleyes.substack.com/',
          isReal: false
        }));
        setBlogs(fallbackCards);
        setLoading(false);
      }
    };

    fetchSubstackPosts();
  }, []);

  return (
    <section className="blogs section" id="blogs">
      <div className="container">
        <div className="blogs-header">
          <span className="label">RESOURCES</span>
          <h2 className="section-title">Latest Insights</h2>
        </div>

        {loading ? (
          <div className="blogs-loading">Loading latest insights...</div>
        ) : (
          <div className="blogs-grid">
            {blogs.map((blog) => (
              <div
                key={blog.id}
                className="blog-card"
                onClick={() => window.open(blog.link, '_blank')}
                style={{ cursor: 'pointer' }}
              >
                <h4 className="blog-title">{blog.title}</h4>
                <p className="blog-excerpt">{blog.excerpt}</p>
                <div className="blog-meta">
                  <span className="blog-date">{blog.date}</span>
                  <a
                    href={blog.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="blog-link"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Read More
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default BlogsResources;
